import {DaznError} from '@dazn/lp-web/src/utils/dazn/DaznError';
import {getCountry, getLanguage} from '@dazn/lp-web/src/utils/dazn/Region';

const GENERIC_UI_ERROR_CODE = 0;
const GENERIC_UI_ERROR_STATUS = 0;
const RAIL = 78;

function servicePath(serviceName: string, version: string): string {
    const startupData = window.dazn.startupData as any;
    return startupData.ServiceDictionary[serviceName].Versions[version]
        .ServicePath;
}

const appendQueryParams = (url: string, params: any) => {
    const urlObj = new URL(url);

    Object.keys(params).forEach((key) => {
        return urlObj.searchParams.append(key, params[key]);
    });
    return urlObj.toString();
};

const fetchRails = async (
    railsInfo: {railId: string; railParams: any}[]
): Promise<any> => {
    const serviceUrl = servicePath('Rail', 'v6');
    try {
        const fetchPromises = railsInfo
            .filter((rail) => rail.railId)
            .map((rail: any) => {
                let urlWithParams = appendQueryParams(serviceUrl, {
                    id: rail?.railId,
                    platform: 'web',
                    country: getCountry().toLocaleLowerCase(),
                    languageCode: getLanguage().toLocaleLowerCase()
                });
                if (rail?.railParams?.params) {
                    urlWithParams = `${urlWithParams}&params=${rail.railParams.params}`;
                }
                return fetch(urlWithParams, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }).then((response) => response.json());
            });

        return await Promise.all(fetchPromises);
    } catch (error) {
        throw new DaznError({
            name: 'Rail',
            message: `Failed to fetch on ${serviceUrl}`,
            code: GENERIC_UI_ERROR_CODE,
            category: RAIL,
            httpStatus: GENERIC_UI_ERROR_STATUS
        });
    }
};

export default fetchRails;
